<div class="fullcontainer" >
  <br />
  <br />

  <div class='titleContainer'>
    <h2 class='header' style='color: #006498'>All Drivers</h2>
    <div>
    <button class='btn btn-secondary' routerLink='/drivers/new'><i class="fas fa-plus"></i> New</button>&nbsp;
    <button class='btn btn-secondary' routerLink='/drivers/bonus'><i class="fas fa-money-bill-wave"></i> Manage Bonus Levels</button>&nbsp;
    <button class='btn btn-secondary' routerLink='/drivers/absence'><i class="fas fa-business-time"></i> Manage Absence</button>&nbsp;
    <button class='btn btn-secondary' routerLink='/drivers/hours'><i class="fas fa-calendar"></i> Manage Hours</button>&nbsp;
    </div>
  </div>
  <br />
  <br />
  <app-grid
entity='driver'
[filters]='this.filters'
[columns]='this.columns'
[buttons]='this.buttons'
[searchFilters]='this.searchFilters'
[searchFields]='this.searchFields'
></app-grid>
